import { render } from "./live-anchor-list.vue?vue&type=template&id=ec16027c&scoped=true"
import script from "./live-anchor-list.vue?vue&type=script&lang=js"
export * from "./live-anchor-list.vue?vue&type=script&lang=js"

import "./live-anchor-list.vue?vue&type=style&index=0&id=ec16027c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec16027c"]])

export default __exports__